import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import bidService from "../services/bidService";
import analyticsService from "../services/analyticsService";

/**
 * Hook personalizado para gestionar la carga de ofertas de hotel
 * @param {string|number} offerId - ID de la oferta
 * @returns {Object} Estado de la oferta
 */
export const useHotelOffer = (offerId) => {
  const [offer, setOffer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchOffer = useCallback(async () => {
    if (!offerId) return;

    try {
      setLoading(true);
      setError(null);
      
      const data = await bidService.getBidById(offerId);
      setOffer(data);

      // Registrar vista de página en Analytics
      analyticsService.pageView(window.location.pathname);
    } catch (err) {
      setError(err.message || "Error al cargar la oferta");
      
      // Si es error de autenticación, redirigir
      if (err.status === 401) {
        navigate("/");
      }
    } finally {
      setLoading(false);
    }
  }, [offerId, navigate]);

  useEffect(() => {
    fetchOffer();
  }, [fetchOffer]);

  return {
    offer,
    loading,
    error,
    refetch: fetchOffer,
  };
};
